import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
interface Props {
  children: React.ReactNode;
}
export function DevTools({
  children
}: Props) {
  return <>
      {children}
      <ReactQueryDevtools initialIsOpen={false} data-sentry-element="ReactQueryDevtools" data-sentry-source-file="DevTools.tsx" />
    </>;
}